<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16wuzN9/tc-custom/9781449423117.jpg?1725275627237" alt="This image is the cover for the book Roger Ebert's Movie Yearbook 2013"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Roger Ebert's Movie Yearbook 2013
      </h1>
      <p class="bookDescription body article font2">
        <p>Roger Ebert’s “criticism shows a nearly unequaled grasp of film history and technique, and formidable intellectual range. . . .” —<i>New York Times</i><br/><br/>Pulitzer Prize–winning film critic Roger Ebert presents more than 600 full-length critical movie reviews, along with interviews, tributes, and journal entries inside <i>Roger Ebert</i><i>’</i><i>s Movie Yearbook 2013.</i><br/><br/>It includes every movie review Ebert has written from January 2010 to July 2012.<br/><br/>Also included in the Yearbook:In-depth interviews with newsmakers and celebritiesTributes to those in the film industry who have passed away recentlyEssays on the Oscars, reports from the Toronto Film Festival, and entries into Ebert's Little Movie Glossary</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Roger Ebert
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6555c7ea